/*! @azure/msal-common v8.0.0 2022-11-07 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Protocol modes supported by MSAL.
 */
var ProtocolMode;
(function (ProtocolMode) {
    ProtocolMode["AAD"] = "AAD";
    ProtocolMode["OIDC"] = "OIDC";
})(ProtocolMode || (ProtocolMode = {}));

export { ProtocolMode };
//# sourceMappingURL=ProtocolMode.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-common/dist/authority/ProtocolMode.js
// module id = 129
// module chunks = 0